import { Component, Input, OnInit } from '@angular/core';
import { PreregApplicationService } from './service/prereg.service';
import { SEBType } from './model/SEBType';

@Component({
    selector: 'app-application-details',
    templateUrl: './applicationDetails.component.html',
    standalone: false
})
export class ApplicationDetailsComponent implements OnInit {
    @Input() application;
    trainingSites = [];
    hasPlacements;
    userSEBType: string = '-';

    constructor(
        private service: PreregApplicationService
    ) { }

    ngOnInit() {
        this.hasPlacements = !!this.application.placements && this.application.placements.length > 0;
        if (this.hasPlacements) {
            const hasMoreThanOnePlacement = this.application.placements.length > 1;
            const placements = this.application.placements;
            (hasMoreThanOnePlacement) ? this.sortPlacements(placements) : this.trainingSites.push(placements[0].trainingSite);
        }
        if(this.application?.seb) this.userSEBType = SEBType[this.application.seb];
    }

    get isPreRegVersionNew() {
        return this.application?.preRegVersion === 'new';
    }

    sortPlacements(placements) {
        placements.sort((placement1, placement2) => {
            return new Date(placement1.endDate).getTime() - new Date(placement2.endDate).getTime();
        }).forEach(placement => {
            this.trainingSites.push(placement.trainingSite);
        });
    }


}

